import { Component } from "../../../modules/Core/Component";
import templateDefault from "../../templates/default/widgets/product_list_view";
import Services from "../../Services/Services";

export default class ProductListView extends Component {
  id = "procut-list-view";
  group = "wishlist";

  template = templateDefault;

  onLoad(data) {
    super.onLoad(data);

    this.setProduct();

    this.checkWishlist();
  }

  setProduct() {
    var product = { ...this.props.product };
    this.setData({
      "default.product": product,
    });
  }

  checkWishlist() {
    Services.get("wishlist").then(([wishlistService]) => {
      var wishlist = wishlistService.getWishlist();
      var product = this.getData("default.product");
      this.setData({
        "default.wishlist": wishlist.some((el) => el === product.slug),
      });
    });
  }

  addToWishList(slug) {
    Services.get("wishlist").then(([wishlistService]) => {
      wishlistService.addToWishList(slug, this);
    });
  }

  removeFromWishList(slug) {
    Services.get("wishlist").then(([wishlistService]) => {
      wishlistService.removeFromWishList(slug, this);
    });
  }
}
